import * as React from 'react'
import Link from 'next/link'

import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded'
import WorkOutlineRoundedIcon from '@mui/icons-material/WorkOutlineRounded'
import PublicRoundedIcon from '@mui/icons-material/PublicRounded'
import CardActionArea from '@mui/material/CardActionArea'
import MuiCard from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

import Text from 'components/atomic/atoms/text'
import Routes from 'utils/routes'

const Card = React.memo(({ title, to, icon }: { title: string; icon: React.ReactNode; to: string }) => {
    return (
        <Link href={to}>
            <a>
                <MuiCard>
                    <CardActionArea sx={{ p: 2 }}>
                        <Stack direction="row" alignItems="center" spacing={2}>
                            {icon}
                            <Text fontWeight={'bold'}>{title}</Text>
                        </Stack>
                    </CardActionArea>
                </MuiCard>
            </a>
        </Link>
    )
})

const WikiDropdown = (props: { onHover: (a: boolean) => void }) => {
    const paths = [
        {
            title: 'Strumenti e Tool',
            to: Routes.WikiTools,
            icon: <ConstructionRoundedIcon fontSize="small" color="primary" />,
        },
        {
            title: 'Linguaggi',
            to: Routes.WikiLanguages,
            icon: <PublicRoundedIcon fontSize="small" color="primary" />,
        },
        {
            title: 'Professioni',
            to: Routes.WikiRoles,
            icon: <WorkOutlineRoundedIcon fontSize="small" color="primary" />,
        },
    ]

    return (
        <Box
            component="footer"
            sx={{ marginTop: 1, borderTop: (theme) => `1px solid ${theme.palette.divider}` }}
            onMouseEnter={() => props.onHover(true)}
            onMouseLeave={() => props.onHover(false)}>
            <Box sx={{ py: { xs: 4, md: 6 } }}>
                <Grid container spacing={{ xs: 4, md: 6 }}>
                    <Grid item xs={12} md={4}>
                        <Stack direction="column">
                            <Text variant="h6" color="text.primary" gutterBottom>
                                La Wiki del programmatore
                            </Text>
                            <Text width={'80%'} variant="subtitle2">
                                Esplora i Tool, Linguaggi e Professioni piu interessanti e calde del momento.
                            </Text>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Grid container spacing={1} justifyContent="space-evenly" height={'100%'} alignItems={'center'}>
                            {paths.map((item) => (
                                <Grid item xs={6} md={4} key={item.title}>
                                    <Card title={item.title} to={item.to} icon={item.icon} />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default WikiDropdown
